import { Box, Card, CardContent, Grid, Skeleton } from '@mui/material';
import { usePreviewFragment } from '../hooks/usePreviewFragment';
import { AudioSkeleton } from './media-detail/audio/AudioSkeleton';
import { VideoSkeleton } from './media-detail/video/VideoSkeleton';

/**
 * Skeleton for the fragment view content.
 * Mirrors FragmentMediaDetail grid composition and chooses audio/video shape from navigation fragment.
 */
export function FragmentViewContentSkeleton() {
  const { fragmentFromNavigation } = usePreviewFragment();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        {fragmentFromNavigation?.mediaType === 'AUDIO' ? (
          <AudioSkeleton showLoader={false} />
        ) : (
          <VideoSkeleton showLoader={false} />
        )}

        <Box mt={2}>
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" gap={2}>
                <Box display="flex" alignItems="center" flexWrap="wrap" columnGap={1} rowGap={1}>
                  <Skeleton variant="rounded" width={180} height={20} />
                  <Skeleton variant="rounded" width={80} height={20} />
                  <Skeleton variant="rounded" width={120} height={20} />
                </Box>
                <Skeleton variant="rounded" width={180} height={20} />
              </Box>
              <Skeleton variant="rounded" width="100%" height={20} sx={{ mt: 1.5 }} />
              <Skeleton variant="rounded" width="86%" height={20} sx={{ mt: 1 }} />
            </CardContent>
          </Card>
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        <Card sx={{ height: '100%', minHeight: 420, display: 'flex', flexDirection: 'column' }}>
          <CardContent sx={{ pb: 1 }}>
            <Skeleton variant="rounded" width={140} height={24} />
          </CardContent>
          <Box sx={{ px: 1.5, pb: 1.5, flex: 1 }}>
            <Skeleton variant="rounded" width="100%" height="100%" />
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}
